import { AuthzRolesActions } from "stores/roles/AuthzRolesStore";
import notifyingAction from "../notifyingAction";
const load = notifyingAction({
  action: AuthzRolesActions.load,
  error: (error, roleId) => ({
    message: `Loading role with id "${roleId}" failed with status: ${error}`
  }),
  notFoundRedirect: true
});
const deleteAction = notifyingAction({
  action: AuthzRolesActions.delete,
  success: (_roleId, roleName) => ({
    message: `Role "${roleName}" was deleted successfully`
  }),
  error: (error, _roleId, roleName) => ({
    message: `Deleting role "${roleName}" failed with status: ${error}`
  })
});
const addMembers = notifyingAction({
  action: AuthzRolesActions.addMembers,
  success: (_roleId, usernames) => ({
    message: `Users:"${usernames.join(", ")}" were assigned successfully`
  }),
  error: (error, _roleId, usernames) => ({
    message: `Assigning users "${usernames.join(", ")}" failed with status: ${error}`
  })
});
const removeMember = notifyingAction({
  action: AuthzRolesActions.removeMember,
  success: (_roleId, username) => ({
    message: `User "${username}" was unassigned successfully`
  }),
  error: (error, _roleId, username) => ({
    message: `Unassign user "${username}" failed with status: ${error}`
  })
});
const loadUsersForRole = notifyingAction({
  action: AuthzRolesActions.loadUsersForRole,
  error: (error, _roleId, roleName) => ({
    message: `Loading users for role "${roleName}" failed with status: ${error}`
  })
});
const loadRolesForUser = notifyingAction({
  action: AuthzRolesActions.loadRolesForUser,
  error: (error, username) => ({
    message: `Loading roles for user "${username}" failed with status: ${error}`
  })
});
const loadRolesPaginated = notifyingAction({
  action: AuthzRolesActions.loadRolesPaginated,
  error: (error) => ({
    message: `Loading roles failed with status: ${error}`
  })
});
export default {
  load,
  delete: deleteAction,
  addMembers,
  removeMember,
  loadUsersForRole,
  loadRolesForUser,
  loadRolesPaginated
};
